import { acss } from '@adornis/chemistry/directives/acss.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@adornis/chemistry/elements/components/x-flex.js';
import '@adornis/chemistry/elements/components/x-grid.js';
import '@adornis/chemistry/elements/components/x-toggle-content.js';
import '@adornis/chemistry/elements/components/x-vr.js';
import { XDialog } from '@adornis/dialog/x-dialog.js';
import type { DialogOptions } from '@adornis/dialog/x-plain-dialog.js';
import '@adornis/fonts/fonts.js';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';

/**
 * @element dla-help-dialog
 */
@customElement('dla-help-dialog')
export class DlaHelpDialog extends XDialog<void> {
  static override get element_name(): string {
    return 'dla-help-dialog';
  }

  override render() {
    return html`
      <x-flex padding="md" space="lg" ${css({ overflowY: 'auto' })}>
        <x-flex space="md" ${css({ display: 'none' })}>
          <x-h1> FAQ </x-h1>
          <x-toggle-content
            .label=${html` <x-text bold> Wie kann ich eine alte Dokumentenversion wiederherstellen? </x-text> `}
            .content=${() => html`
              <x-text>
                Um ein Dokument wieder herzustellen, nutze (Beschreibung, wo sich die Buttons dafür befinden und wie die
                Bedienung funktioniert).
              </x-text>
            `}
          ></x-toggle-content>
          <x-toggle-content
            .label=${html` <x-text bold> Wie kann ich eine alte Dokumentenversion wiederherstellen? </x-text> `}
            .content=${() => html`
              <x-text>
                Um ein Dokument wieder herzustellen, nutze (Beschreibung, wo sich die Buttons dafür befinden und wie die
                Bedienung funktioniert).
              </x-text>
            `}
          ></x-toggle-content>
          <x-toggle-content
            .label=${html`
              <x-text bold> Ich kann zwar Kommentare sehen, aber kein neues hinzufügen. Warum nicht? </x-text>
            `}
            .content=${() => html`
              <x-text> Um kommentieren zu können, musst du einen Account besitzen und im Tool angemeldet sein. </x-text>
            `}
          ></x-toggle-content>
          <x-toggle-content
            .label=${html` <x-text bold> Wie kann ich einen Account erstellen? </x-text> `}
            .content=${() => html`
              <x-text>
                Vielen Dank für dein Interesse! Leider sind momentan nur Personen für einen Account vorgesehen, die der
                Goethe Universität Frankfurt angehörig sind. Besteht dennoch ein starkes Interesse an einem eigenen
                Account, wende dich bitte and die folgende Adresse octipad@studiumdigitale.uni-frankfurt.de . Bitte gib
                in deiner Email mit an, warum du einen Account benötigst.
              </x-text>
            `}
          ></x-toggle-content>
        </x-flex>
        <x-flex space="md">
          <x-h1> Keyboard Shortcuts </x-h1>
          <x-grid
            columns="1fr  1fr"
            ${acss({
              'x-text': { borderBottom: `1px solid ${this.colors.neutral.shade(50)}`, padding: this.spacing.sm },
            })}
          >
            ${[
              this._gridLine('strg + c', 'Kopieren'),
              this._gridLine('strg + x', 'Ausschneiden'),
              this._gridLine('strg + v', 'Einfuegen'),
              this._gridLine('strg + umschalt + v', 'Einfuegen ohne Formattierung'),
              this._gridLine('strg + y', 'Rueckgaengig machen'),
              this._gridLine('strg + z', 'Wiederherstellen'),
              this._gridLine('strg + enter', 'Zeilenumbruch'),
            ]}
            ${[
              this._gridLine('strg + b', 'Fett'),
              this._gridLine('strg + i', 'Kursiv'),
              this._gridLine('strg + u', 'Unterschreichen'),
              this._gridLine('strg + umschalt + s', 'Durchstreichen'),
              this._gridLine('strg + umschalt + h', 'markieren'),
            ]}
            ${[
              this._gridLine('strg + alt + 0', 'Normale Text formattierung'),
              this._gridLine('strg + alt + 1', 'Heading 1'),
              this._gridLine('strg + alt + 2', 'Heading 2'),
              this._gridLine('strg + alt + 3', 'Heading 3'),
              this._gridLine('strg + alt + 4', 'Heading 4'),
              this._gridLine('strg + umschalt + l', 'Links anordnen'),
              this._gridLine('strg + umschalt + e', 'Zentriert anordnen'),
              this._gridLine('strg + umschalt + r', 'Rechts anordnen'),
            ]}
            ${[this._gridLine('strg + z', '')]}
          </x-grid>
        </x-flex>
      </x-flex>
    `;
  }

  private _gridLine(shortcut: string, command: string) {
    return html`
      <x-text> ${shortcut} </x-text>
      <x-text> ${command} </x-text>
    `;
  }

  override getInnerWrapper(options: Required<DialogOptions>) {
    const wrapper = super.getInnerWrapper(options);
    wrapper.style.setProperty('height', '80vh');
    wrapper.style.setProperty('width', '80vw');
    return wrapper;
  }
}
